import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api, getVisitorId } from "@/lib/api";

// Injects Google Analytics 4 (if a Measurement ID is configured in admin)
// and records first-party page views for the built-in analytics dashboard.
export function SiteAnalytics() {
  const location = useLocation();
  const ga4Ready = useRef(false);
  const lastPath = useRef(null);

  // Load GA4 measurement id once and inject gtag if present
  useEffect(() => {
    api.get("/settings").then((r) => {
      const id = r.data?.ga4_measurement_id;
      if (!id || ga4Ready.current) return;
      ga4Ready.current = true;
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", id, { send_page_view: false });
      window.__ga4_id = id;
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const path = location.pathname;
    if (path === lastPath.current) return;
    lastPath.current = path;
    // Do not count admin/login screens as public traffic
    if (path.startsWith("/admin") || path.startsWith("/login")) return;

    api.post("/track", {
      path,
      referrer: document.referrer || "",
      visitor_id: getVisitorId(),
    }).catch(() => {});

    if (window.gtag && window.__ga4_id) {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname]);

  return null;
}
